/* eslint-disable react/jsx-props-no-spreading, react/no-unknown-property */
import { useBoxProjectedEnv, useCubeTexture } from '@react-three/drei'
import React from 'react'
import * as THREE from 'three'

export interface ParallaxMaterialProps {
  assets: {
    path: string
    px: string
    nx: string
    py: string
    ny: string
    nz: string
    pz: string
  }
  projectionSettings: {
    position: [number, number, number]
    scale: [number, number, number]
    eular: [number, number, number]
  }
}

function ParallaxMaterial({
  assets,
  projectionSettings,
}: ParallaxMaterialProps) {
  const [ex, ey, ez] = projectionSettings.eular

  const projectionProps = useBoxProjectedEnv(
    projectionSettings.position,
    projectionSettings.scale
  )

  const envMap = useCubeTexture(
    [assets.px, assets.nx, assets.py, assets.ny, assets.pz, assets.nz],
    { path: assets.path }
  )

  envMap.mapping = THREE.CubeReflectionMapping
  envMap.colorSpace = THREE.SRGBColorSpace
  envMap.magFilter = THREE.LinearFilter
  envMap.minFilter = THREE.LinearMipmapLinearFilter

  return (
    <meshStandardMaterial
      {...(projectionProps as unknown as THREE.MeshStandardMaterial)}
      envMap={envMap}
      envMapIntensity={1}
      roughness={0}
      metalness={1}
      envMapRotation={new THREE.Euler(ex, ey, ez)}
      side={THREE.DoubleSide}
    />
  )
}

export default ParallaxMaterial
